export enum ELocales {
  uk = 'uk',
  en = 'en',
}
